import { render, staticRenderFns } from "./login-with-sms.vue?vue&type=template&id=54ccd6ed&"
import script from "./login-with-sms.vue?vue&type=script&lang=js&"
export * from "./login-with-sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports